if (!customElements.get('modanie-hero-editable')) {
  customElements.define('modanie-hero-editable', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-modanie-hero-slide]')];
      this.copy = this.querySelector('[data-modanie-hero-copy]');
      this.index = Math.max(0, this.slides.findIndex(s => s.classList.contains('is-active')));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.selected = false;
      this.interval = Number.parseInt(this.dataset.interval, 10) || 7000;
      this.querySelector('[data-hero-controls]').hidden = this.slides.length < 2;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.addEventListener('focusin', e => { this.focused = this.copy.contains(e.target); this.schedule(); }, options);
      this.addEventListener('focusout', e => { this.focused = this.copy.contains(e.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', e => { this.playing = this.dataset.autoplay === 'true' && !e.matches;  this.schedule(); }, options);
      this.addEventListener('shopify:block:select', e => {
        const index = this.slides.findIndex(s => s.dataset.blockId === e.detail.blockId);
        if (index < 0) return;
        this.selected = true;
        this.show(index);
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.selected = false; this.schedule(); }, options);
      
      this.show(this.index);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.playing || this.hovered || this.focused || this.selected || document.hidden || this.slides.length < 2) return;
      this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
    }
    show(index) {
      if (!this.slides.length || !Number.isInteger(index)) return;
      this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
      const slide = this.slides[this.index];
      const template = slide.querySelector('[data-slide-copy]');
      if (template) this.copy.replaceChildren(template.content.cloneNode(true));
      else {
        this.copy.querySelector('[data-modanie-hero-eyebrow]').textContent = slide.dataset.eyebrow;
        this.copy.querySelector('[data-modanie-hero-heading]').textContent = slide.dataset.heading;
      }
      this.schedule();
    }
  });
}
